import { API, authClient } from "../index";

export const postProductType = async (productType, accessToken) => {
	return authClient(accessToken).post(`${API}/product-types`, productType);
};

export const getProductTypes = (accessToken) => {
	return authClient(accessToken).get(`${API}/product-types`);
};

export const getProductTypeById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/product-types/${id}`);
};

export const updateProductType = async (id, productType, accessToken) => {
	return authClient(accessToken).put(
		`${API}/product-types/${id}`,
		productType
	);
};

export const deleteProductType = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/product-types/${id}`);
};
